import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

export const CustomSelect = ({ value, onChange, options, icon: Icon, testId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={selectRef}>
      <div className="flex items-center space-x-2">
        {Icon && <Icon className="w-4 h-4 text-primary" />}
        <button
          data-testid={testId}
          onClick={() => setIsOpen(!isOpen)}
          className="w-full bg-slate-900 border border-white/20 text-foreground px-4 py-3 rounded-full text-sm uppercase tracking-wider focus:outline-none focus:border-primary transition-colors flex items-center justify-between"
        >
          <span className="truncate">{value}</span>
          <ChevronDown size={16} className={`transition-transform flex-shrink-0 ml-2 ${isOpen ? 'rotate-180' : ''}`} />
        </button>
      </div>

      {isOpen && (
        <div className="absolute top-full mt-2 left-0 right-0 bg-slate-900 border border-white/10 rounded-2xl shadow-2xl overflow-hidden z-50 max-h-60 overflow-y-auto">
          {options.map((option) => (
            <button
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className={`w-full text-left px-4 py-3 text-sm uppercase tracking-wider transition-colors ${
                value === option.value
                  ? 'bg-primary/20 text-primary'
                  : 'text-foreground hover:bg-white/5'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
